export default __webpack_public_path__ + "static/media/license.b57d3329.pdf";